import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import CredittentWrapper from "@components/layouts/creditTentWrapper";

import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";

export default function CredittentHome(): ReactElement {
    return (
        <CredittentWrapper>
            <TermsAndConditions
                category="Credit Repair"
                domain="Credittent.com"
            />
        </CredittentWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
